import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// Third-party styles and libraries
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';
import AOS from 'aos';

import { CssBaseline, StyledEngineProvider } from '@mui/material';

// Project Imports
import { store } from './store';
import Routes from './routes';
import { FirebaseProvider } from 'contexts/FirebaseContext';
import NavigationScroll from './views/NavigationScroll';

import { AppThemeProvider } from 'contexts/ThemeContext'; // Adjust path if needed

const App = () => {
    
    // Initialize AOS animations on first load (This remains unchanged)
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    return (
        <Provider store={store}>
            <StyledEngineProvider injectFirst>
                {/* ===================================================================== */}
                {/* THIS IS THE KEY CHANGE */}
                {/* We wrap the application in our new AppThemeProvider. */}
                {/* It will now manage the theme for every single component. */}
                <AppThemeProvider>
                    <CssBaseline />
                    <BrowserRouter>
                        <NavigationScroll>
                            <FirebaseProvider>
                                <Routes />
                            </FirebaseProvider>
                        </NavigationScroll>
                    </BrowserRouter>
                </AppThemeProvider>
                {/* ===================================================================== */}
            </StyledEngineProvider>
        </Provider>
    );
};

export default App;